// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_12884","block":"_10377","banner":"_11820","item":"_16829","media":"_4299","indicator2":"_3050","current":"_875","indicator":"_4694","icon":"_6159","total":"_11539"};